
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mainBus } from '@/main';

@Component
export default class VContext extends Vue {
    @Prop({ type: String, default: '' }) eventName!: string;
    public displayFn: (item: unknown) => string = (item) => String(item);
    public visible = false;
    public items: unknown = [];

    /**
     * @description action by select item
     */
    select(value: unknown) {
        mainBus.$emit(`${this.eventName}:Select`, value);
    }

    public show(x: number, y: number) {
        this.visible = true;

        this.setElementPosition(x, y);
    }

    public hide() {
        this.visible = false;
    }

    displayContext(x: number, y: number, items: unknown, displayFn: (item: unknown) => string) {
        this.show(x, y);
        this.items = items;
        if (displayFn) this.displayFn = displayFn;
    }

    /**
     * @description set position of context menu by input params
     * @param {number} x - position of context menu by axios position
     * @param {number} y - position of context menu by axios position
     */
    public setElementPosition(x: number, y: number) {
        const elementHeight = this.$el.clientHeight;
        const elementWidth = this.$el.clientWidth;

        const maxPositionX = window.innerWidth - elementWidth;
        const maxPositionY = window.innerHeight - elementHeight;

        y = y > maxPositionY ? maxPositionY : y;
        x = x > maxPositionX ? maxPositionX : x;

        (this.$el as HTMLElement).style.top = `${y}px`;
        (this.$el as HTMLElement).style.left = `${x}px`;
    }

    mounted() {
        mainBus.$on(`${this.eventName}:Open`, this.displayContext);
        mainBus.$on(`${this.eventName}:Close`, this.hide);

        window.addEventListener('wheel', this.hide);
        this.$once('hook:beforeDestroy', () => window.removeEventListener('wheel', this.hide));
    }

    beforeDestroy() {
        mainBus.$off(`${this.eventName}:Open`);
        mainBus.$off(`${this.eventName}:Close`);
    }
}
